export enum PatientInfoValues {
  SPECIES = 'species',
  BREED = 'breed',
  WEIGHT = 'weight',
  BIRTH_DATE = 'birthDate',
  GENDER = 'gender',
  OWNER_NAME = 'ownerName',
  OWNER_EMAIL = 'ownerEmail',
  OWNER_PHONE_NUMBER = 'ownerPhoneNumber'
}
